<div class="iproject-container">
    <app-internal-project-detail></app-internal-project-detail>
    <app-internal-project-list></app-internal-project-list>
</div>


// WEBPACK FOOTER //
// ./src/app/internal-project/internal-project.component.html